import { Component, Input, Output, EventEmitter, Renderer2, ElementRef, SimpleChanges, OnChanges } from '@angular/core';
import { UiIcon } from '../ui-icon/ui-icon.models';

export enum TagType {
    FILLED = 'filled',
    OUTLINE = 'outline'
}
@Component({
    selector: 'ui-tag',
    template:`
            <div class="tag-body">
                <ui-icon class="left"
                    [ngClass]="{'pointer': iconLeft.hasAction}"
                    *ngIf="iconLeft"
                    [type]="iconLeft.type"
                    [icon]="iconLeft.value"
                    [size]="16"
                    shape="icon"
                    (click)="clickIconLeft($event)">
                </ui-icon>
                <ng-content></ng-content>
                <ui-icon class="right"
                    [ngClass]="{'pointer': iconRight.hasAction}"
                    *ngIf="iconRight"
                    [type]="iconRight.type"
                    [icon]="iconRight.value"
                    [size]="16"
                    shape="icon"
                    (click)="clickIconRight($event)">
                </ui-icon>
            </div>
    `,
    host: {
        '[class.tag]': 'true',
    }
})

export class UiTagComponent implements OnChanges {
    @Input() iconLeft: UiIcon.Svg;
    @Input() iconRight: UiIcon.Svg;

    @Input() color: string = 'primary';
    @Input() type: TagType = TagType.OUTLINE;

    @Output() iconLeftEvent: EventEmitter<any> = new EventEmitter();
    @Output() iconRightEvent: EventEmitter<any> = new EventEmitter();

    private _colorClass;
    private _typeClass;

    constructor(private renderer: Renderer2, private el: ElementRef) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes) {
            this.renderer.removeClass(this.el.nativeElement, this._colorClass);
            this.renderer.removeClass(this.el.nativeElement, this._typeClass);
            this.addColors();
        }
    }

    /**
     *
     * Add classes based on TagType
     * @private
     * @memberof UiTagComponent
     */
    private addColors(): void {
        this._colorClass = this.type === TagType.FILLED ? `bg-${this.color}` : `color-${this.color}`;
        this._typeClass = `tag-${this.type}`;
        this.renderer.addClass(this.el.nativeElement, this._colorClass);
        this.renderer.addClass(this.el.nativeElement, this._typeClass);
    }

    /**
     *
     * Emit click event from leftIcon
     * @param {*} $event
     * @memberof UiTagComponent
     */
    public clickIconLeft($event): void {
        if (this.iconLeft.hasAction) {
            this.iconLeftEvent.emit($event);
        }
    }

    /**
     *
     * Emit click event from rightIcon
     * @param {*} $event
     * @memberof UiTagComponent
     */
    public clickIconRight($event): void {
        if (this.iconRight.hasAction) {
            this.iconRightEvent.emit($event);
        }
    }
}
